import { useNavigate } from 'react-router-dom';

import { confirmLeaveWithoutSaving } from '../../common/confirmLeaveWithoutSaving';

import { MatchingSource } from './matching.types';
import { matchingListPath } from './matchingPresentation';

export const useOpenMatchingPage = (source: MatchingSource) => {
  const navigate = useNavigate();
  return (dirty: boolean) => {
    const open = () => navigate(matchingListPath(source));
    if (!dirty) return open();
    confirmLeaveWithoutSaving('Matches use saved candidate and project data.', open);
  };
};
